<template>
  <div class="product-list-container">
    <div class="product-grid">
      <div 
        v-for="(item, index) in goodList" 
        :key="index" 
        class="product-card"
        @click="goDetail(item)"
      >
        <!-- 商品图片 -->
        <div class="product-image-wrapper">
          <img v-lazy="item.image" :alt="item.name" class="product-image" />
          <!-- 免息标签 -->
          <div class="interest-free-tag">
            <span style="font-size: 0.32rem;">20%</span>
            <br>积分抵扣  
          </div>
        </div>
        
        <!-- 商品信息 -->
        <div class="product-info">
          <div class="product-name">{{ item.store_name }}</div>
          <div class="price-section">
            <div class="installment-price">
              <span class="price-symbol">¥</span>
              <span class="price-value">{{ (item.price / item.fenqi_num).toFixed(2) }}</span>
              <span class="installment-unit">/期起</span>
            </div>
            <div class="original-price" v-if="item.ot_price">¥{{ item.ot_price}}</div>
            <div class="price" v-else>¥{{ item.price }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { goShopDetail } from "@libs/order";
export default {
  name: "GoodList",
  props: {
    goodList: {
      type: Array,
      default: () => [],
    },
    isSort: {
      type: Boolean,
      default: true,
    },
  },
  data: function() {
    return {};
  },
  methods: {
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-list-container {
  background: #fff;
  padding: 0.2rem;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.2rem;
}

.product-card {
  background: #fff;
  border-radius: 0.15rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  &:active {
    opacity: 0.9;
    transform: scale(0.99);
  }
}

.product-image-wrapper {
  position: relative;
  width: 100%;
  padding-top: 100%;
  overflow: hidden;
}

.product-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
//   height: 100%;
  object-fit: cover;
}

.interest-free-tag {
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%);
  color: #fff;
  font-size: 0.18rem;
  padding: 0.08rem 0.15rem;
  border-radius: 0 0 0 0.1rem;
  font-weight: 500;
}

.product-info {
  padding: 0.15rem;
}

.product-name {
  font-size: 0.24rem;
  color: #333;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 2.8em;
}

.price-section {
  margin-top: 0.1rem;
}

.installment-price {
  display: flex;
  align-items: baseline;
}

.price-symbol {
  font-size: 0.22rem;
  color: #ff4d4f;
  font-weight: bold;
}

.price-value {
  font-size: 0.3rem;
  color: #ff4d4f;
  font-weight: bold;
}

.installment-unit {
  font-size: 0.18rem;
  color: #ff4d4f;
  margin-left: 0.05rem;
}

.original-price {
  font-size: 0.2rem;
  color: #999;
  margin-top: 0.05rem;
  text-decoration: line-through;
}
.price{
     font-size: 0.2rem;
  color: #999;
  margin-top: 0.05rem;
}
</style>